// extracted by mini-css-extract-plugin
export default {"landingPage":"Campaign2_landingPage__Say+z"};